export const APP_NAMES = {
  HOME: "home",
  LOGIN: "login",
  PROFILE: "profile",
  PAYMENT: "payment",
};

export const Routes = [
  {
    name: APP_NAMES.HOME,
    link: "/",
  },
  {
    name: APP_NAMES.LOGIN,
    link: "/login",
  },
  {
    name: APP_NAMES.PROFILE,
    link: "/profile",
  },
  {
    name: APP_NAMES.PAYMENT,
    link: "/payment",
  },
];
